export type CatchDraftMode = "one_sentence" | "catch_me" | "reflect" | "before";

export type CatchDraft = {
  version: 1;
  saved_at: number;
  will_id: string;
  mode: CatchDraftMode;
  statement: string;
  before_context: string;
  reflect_answers: [string, string, string];
};

export const OFFLINE_DRAFT_KEY = "wordwill.catch.draft.v1";
export const OFFLINE_DRAFT_MAX_AGE_MS = 7 * 24 * 60 * 60 * 1000;

function storage(): Storage | null {
  try { return typeof window === "undefined" ? null : window.localStorage; }
  catch { return null; }
}

export function loadCatchDraft(nowMs = Date.now()): CatchDraft | null {
  const store = storage();
  if (!store) return null;
  try {
    const raw = store.getItem(OFFLINE_DRAFT_KEY);
    if (!raw) return null;
    const value = JSON.parse(raw) as Partial<CatchDraft>;
    const answers = Array.isArray(value.reflect_answers) ? value.reflect_answers : [];
    if (value.version !== 1 || typeof value.saved_at !== "number" || nowMs - value.saved_at > OFFLINE_DRAFT_MAX_AGE_MS || typeof value.will_id !== "string" || !["one_sentence", "catch_me", "reflect", "before"].includes(String(value.mode)) || typeof value.statement !== "string" || typeof value.before_context !== "string" || answers.length !== 3 || !answers.every(item => typeof item === "string")) {
      store.removeItem(OFFLINE_DRAFT_KEY);
      return null;
    }
    return { version: 1, saved_at: value.saved_at, will_id: value.will_id, mode: value.mode as CatchDraftMode, statement: value.statement, before_context: value.before_context, reflect_answers: answers as [string, string, string] };
  } catch {
    store.removeItem(OFFLINE_DRAFT_KEY);
    return null;
  }
}

export function saveCatchDraft(input: Omit<CatchDraft, "version" | "saved_at">, nowMs = Date.now()): CatchDraft | null {
  const store = storage();
  if (!store) return null;
  const draft: CatchDraft = { version: 1, saved_at: nowMs, ...input };
  try { store.setItem(OFFLINE_DRAFT_KEY, JSON.stringify(draft)); return draft; }
  catch { return null; }
}

export function clearCatchDraft(): void {
  try { storage()?.removeItem(OFFLINE_DRAFT_KEY); }
  catch { /* no-op: draft storage is best effort only */ }
}
